import { PropsWithChildren } from "react";

import styles from "@components/NumberCircle.module.css";
import { Colors } from "@utils/colorUtils";

type Props = PropsWithChildren<{
  color: Colors;
  position: "top" | "bottom";
}>;

const NumberCircle = ({ children, color, position }: Props) => (
  <div className={[styles.dot, styles[color], styles[position]].join(" ")}>{children}</div>
);

export default NumberCircle;
